export enum MenuUrlEnum {
  BaseUrl = "/",
  Login = "/login",
  Logout = "/logout",
  PasswordRecover = "/password-recover",
  EmailApproveReject = "/email/:approveOrReject/:eventKey/:uidKey",
  DashboardPrecatorios = "/dashboard/precatorios",
  DashboardTrades = "/dashboard/trades",
  WfPreCartorio = "/workflow/pre-cartorio",
  WfCartorio = "/workflow/cartorio",
  WfValidSpecialProject = "/workflow/special-project/valid-trade",
  WfApprovedSpecialProject = "/workflow/special-project/approved-trade",
  WfPending = "/workflow/pending",
  WfPricing = "/workflow/pricing",
  WfPricingEdit = "/workflow/pricing/:id",
  WfContractInformation = "/workflow/contract-information",
  WfDocumentValidation = "/workflow/document-validation",
  WfDocumentApproval = "/workflow/document-approval",
  WfLegalCertificates = "/workflow/legal-certificates",
  WfAcceptanceTerm = "/workflow/acceptance-term",
  WfFraud = "/workflow/fraud",
  WfPreFraud = "/workflow/pre-fraud",
  WfCompliance = "/workflow/compliance",
  WfCredit = "/workflow/credit-validation",
  WfDiligence = "/workflow/diligence",
  WfSpecialSituation = "/workflow/special-situation",
  WfAnalysis = "/workflow/analysis",
  WfAbono = "/workflow/abono",
  WfCheckDocumentPage = "/workflow/check-documents",
  WfCessionTerm = "/workflow/cession-term",
  WfTransferTerm = "/workflow/transfer-term",
  WfAttorney = "/workflow/attorney",
  WfDisbursement = "/workflow/disbursement",
  WfDisbursementAwaiting = "/workflow/disbursement-awaiting",
  WfDisbursementReject = "/workflow/disbursement-reject",
  WfPostPurchase = "/workflow/post-purchase",
  WfRejected = "/workflow/rejected",
  WfArchived = "/workflow/archived",
  WfPendency = "/workflow/pendency",
  WfTransferAdministrator = "/workflow/transfer-administrator",
  WfTransferAdministratorApproval = "/workflow/transfer-administrator-approval",
  WfConsorcieiWaitingSignatures = "/workflow/consorciei/waiting_signatures",
  WfConsorcieiWaitingAnalysis = "/workflow/consorciei/waiting_analysis",
  WfConsorcieiWaitingBuyerSignatures = "/workflow/consorciei/waiting_buyer_signatures",
  WfConsorcieiWaitingTransference = "/workflow/consorciei/waiting_transference",
  WfConsorcieiError = "/workflow/consorciei/error",
  WfConsorcieiPendencies = "/workflow/consorciei/pendencies",
  WfConsorcieiReport = "/workflow/consorciei/report",
  WfAdministratorApprovalRejecteds = "/workflow/administrator-approval-rejecteds",
  WfAdministratorApprovalPendencies = "/workflow/administrator-approval-pendencies",
  WfAdministratorApprovalById = "/workflow/administrator-approval-pendency",
  WfAdministratorApprovalRejectedById = "/workflow/administrator-approval-rejected",
  WfPanCessionTerm = "/workflow/cession-term/pan",
  WfRejectedList = "/workflow/trade/rejected",
  WfAwaitingTransferTerm = "/workflow/awaiting-transfer-term",
  WfAwaitingTermsAndStatement = "/workflow/awaiting-terms-and-statement",

  ToolsCalculatorDap = "/tools/calculator/calculator-dap",
  ToolsCalculatorManual = "/tools/calculator/calculator-manual",
  ToolsMonitoringOfficer = "/tools/monitoring/officers",
  ToolsMonitoringMigalhas = "/tools/monitoring/migalhas",
  ToolsMonitoringTrades = "/tools/monitoring/trades",
  ToolsBigDataCorp = "/tools/bigdatacorp",
  ToolsPrecificacaoLote = "/tools/precificacao-lote",
  ToolsDetalhePrecificacao = "/tools/precificacao-lote/:id",
  ToolsBCheckBatch = "/tools/bcheck-batch",
  ToolsDetailBCheckBatch = "/tools/bcheck-batch/:id",
  ToolsValorExposicaoLote = "/tools/valor-exposicao-lote",
  ToolsValorExposicaoLoteDetail = "/tools/valor-exposicao-lote/:id",
  EntubaCedenteCota = "/entuba/cedente-cota",
  EntubaAtualizacaoCedente = "/entuba/atualizacao-cedente",
  EntubaAtualizacaoCedenteDetail = "/entuba/atualizacao-cedente/:id",
  // -----------------------------------------Entuba cessionario cota  rota------------------------------------------------- 
  EntubaCessionarioCota = "/entuba/cessionario-cota",
  EntubaAtualizacaoCessionarioDetail = "/entuba/cessionario-cota/:id",
  // -----------------------------------------Entuba cessionario cota rota------------------------------------------------- 

  // -----------------------------------------Entuba repasse trade-------------------------------------------------------
  EntubaRepasseTrade = "/entuba/repasse-trade",
  EntubaRepasseTradeDetail = "/entuba/repasse-trade/:id",
  // -----------------------------------------Entuba repasse trade------------------------------------------------------- 

  EntubaAtualizacaoDespesa = "/entuba/atualizacao-despesa",
  EntubaAtualizacaoDespesaDetail = "/entuba/atualizacao-despesa/:id",

  EntubaOCR = "/entuba/ocr",
  EntubaOCRDetail = "/entuba/ocr/:id",

  EntubaTransferApproval = "/entuba/transfer-approval",
  EntubaTransferApprovalDetail = "/entuba/transfer-approval/:id",
  EntubaCedenteCotaDetail = "/entuba/cedente-cota/:id",
  EntubaBCheck = "/entuba/bcheck",
  EntubaBCheckDetail = "/entuba/bcheck/:id",
  ManagerCartorioNew = "/manager/cartorio/new",
  ManagerCartorioEdit = "/manager/cartorio/:id",
  ManagerCartorio = "/manager/cartorio",
  ManagerCartorioList = "/manager/cartorio/list",
  ManagerCommonDomain = "/manager/common-domain",
  ManagerProfiles = "/manager/profiles",
  ManagerProfilesEdit = "/manager/profiles/:id",
  ManagerProfilesNew = "/manager/profiles/new",
  ManagerRules = "/manager/rules",
  ManagerRulesEdit = "/manager/rules/:id",
  ManagerRulesNew = "/manager/rules/new",
  ManagerResources = "/manager/resources",
  ManagerUser = "/manager/users",
  ManagerUserEdit = "/manager/users/:id",
  ManagerUserNew = "/manager/users/new",
  ManagerFiles = "/manager/files",
  ManagerOfficers = "/manager/officers",
  ManagerOfficersEdit = "/manager/officers/:id",
  ManagerOfficersNew = "/manager/officers/new",
  ManagerLawFirmList = "/manager/law-firm/list",
  ManagerLawFirmNew = "/manager/law-firm/new",
  ManagerLawFirmEdit = "/manager/law-firm/:id",
  ManagerLawFirm = "/manager/law-firm",
  ManagerSpecialProject = "/manager/special-project",
  ManagerSpecialProjectEdit = "/manager/special-project/:id",
  ManagerSpecialProjectNew = "/manager/special-project/new",
  ManagerEmailsBoilerplates = "/manager/emails/boilerplates",
  ManagerEmailsBoilerplatesEdit = "/manager/emails/boilerplates/:id",
  ManagerEmailsBoilerplatesNew = "/manager/emails/boilerplates/new",
  ManagerEmailsTemplates = "/manager/emails/templates",
  ManagerEmailsTemplatesEdit = "/manager/emails/templates/:id",
  ManagerEmailsTemplatesNew = "/manager/emails/templates/new",
  ManagerEmailsMounted = "/manager/emails/mounted",
  ManagerEmailsMountedEdit = "/manager/emails/mounted/:id",
  ManagerEmailsMountedNew = "/manager/emails/mounted/new",

  ManagerTraderConsulter = "/manager/traders/consulters",
  ManagerTraderConsulterEdit = "/manager/traders/consulters/:id",
  ManagerTraderConsulterNew = "/manager/traders/consulters/new",

  ManagerSpread = "/manager/spreads",
  ManagerSpreadEdit = "/manager/spreads/:id",
  ManagerSpreadNew = "/manager/spreads/new",

  ManagerGlobalSpread = "/manager/global/spreads",
  ManagerSpreadGlobalEdit = "/manager/global/spreads/:id",
  ManagerSpreadGlobalNew = "/manager/global/spreads/new",

  ConfigurationCourtTypeNew = "/configuration/court-type/new",
  ConfigurationCourtTypeEdit = "/configuration/court-type/:id",
  ConfigurationCourtType = "/configuration/court-type",
  ConfigurationCourtTypeList = "/configuration/court-type/list",
  ConfigurationCourtNew = "/configuration/court/new",
  ConfigurationCourtEdit = "/configuration/court/:id",
  ConfigurationCourt = "/configuration/court",
  ConfigurationCourtList = "/configuration/court/list",
  ConfigurationCourtExpectedPaymentNew = "/configuration/court-expected-payment/new",
  ConfigurationCourtExpectedPaymentEdit = "/configuration/court-expected-payment/:id",
  ConfigurationCourtExpectedPayment = "/configuration/court-expected-payment",
  ConfigurationCourtExpectedPaymentList = "/configuration/court-expected-payment/list",
  ConfigurationSpreadNew = "/configuration/spread/new",
  ConfigurationSpreadEdit = "/configuration/spread/:id",
  ConfigurationSpread = "/configuration/spread",
  ConfigurationSpreadList = "/configuration/spread/list",

  ReportOperationCost = "/report/operation-cost/trades",
  ReportUniproof = "/report/uniproof",
  ReportExposure = "/report/exposure",
  ReportPostPurchaseStatus = "/report/post-purchase/status",
  ReportPostPurchaseAcquired = "/report/post-purchase/acquired",
  ReportPostPurchaseMovement = "/report/post-purchase/movement",
  ReportPostPurchaseHistorySource = "/report/post-purchase/history/source",
  ReportPostPurchaseHistoryType = "/report/post-purchase/history/type",
  ContingencyCorretionTable = "/contingency/correction-table",
  ContingencyMaintenanceTrade = "/contingency/trade-update",
  ContingencyReloadBCheck = "/contingency/back-ground-check",
  ContingencyBackPhase = "/contingency/rollback-phase",
  RestartTerm = "/contingency/restart-terms",
  ContingencyUpdateTradeProposal = "/contingency/update/proposal/trade",

  AdministratorNew = "/manager/administrator/new",
  AdministratorEdit = "/manager/administrator/:id",
  Administrator = "/manager/administrator",
  Assignee = "/manager/assignees",
  AssigneeV1 = "/manager/assignees/v1",
  AuthRuleNew = "/manager/auth/rule/new",
  AuthRuleEdit = "/manager/auth/rule",
  AuthRules = "/manager/auth/rules",
  Permissions = "/manager/permissions",
  Permission = "/manager/permission",
  PermissionNew = "/manager/permission/new",
  PdfModelRegister = "/manager/extract/model-register",
  EntubaCotaPrice = "/entuba/cota-price",
  EntubaCotaPriceDetail = "/entuba/cota-price/:id",

  PayslipCreated = "/wallet/payslip/created",
  TradeWalletList = '/wallet/trades',
  CalculadoraCotaCarrego = '/wallet/calculadora-carrego',
  TradeWalletEntubaAtualizaocaoLote = '/wallet/atualizacao-lote',
  TradeWalletEntubaRecebiveis = '/wallet/receivables',
  WfWalletTradeReceivables = "/wallet/trades/receivables",
  WfWalletQuotaInstallment = "/wallet/cota/parcelas",
  WfWalletQuotaInstallmentBoletador = "/wallet/cota/parcelas/boletador",
  // -----------------------------------------Carteira Extrato de Cotas em Lote S3--------------------------------------------------
  WfWalletExtractDocumentBatch = "/wallet/batch/extract",
  WfWalletExtractDocumentBatchDetail = "/wallet/batch/extract/:id",
  // -----------------------------------------Carteira Extrato de Cotas em Lote S3-------------------------------------------------
  DashboardPhases = "/dashboard/phases",

  ReportPhasesCompleted = "/report/phases/completed",
  ReportPhasesSimplified = "/report/phases/simplified",
  ReportIndicators = '/report/indicators',

  Contemplato = "/contemplato",
  AdminsitratorApprovalTransferQuota = "/administrator/approval-transfer-quota",
  AdministratorPendingSignature = "/administrator/sign-pending-documents",
  AdministratorPendingSignatureAndTransfer = "/administrator/sign-pending-documents-and-transfer",
  AdminsitratorQuotaPurchase = "/administrator/quota-purchase",
  AdministratorReport = "/administrator/report",
  AdministratorReadyDirsbursement = "/administrator/disbursement",
  AdministratorRejecDisbursement = "/administrator/disbursement/reject",

  SignaturesBatchCreate = "/signatures/batch/create",
  SignaturesBatchList = "/signatures/batch/list",
  SignaturesBatchSign = "/signatures/batch/sign",

  WalletCotaDeativation = '/wallet/cota/deactivation',

  BusinessPartnerReport = '/bp/report',
  BusinessPartnerB2BReport = '/bp/partner-report',
  BusinessPartnerEntuba = '/bp/entuba',
  BusinessPartnerEntubaSingleLeads = '/bp/entuba/single-leads/',
  BusinessPartnerEntubaSingleNew = "/bp/entuba/single-leads/new",
  BusinessPartnerEntubaSingleEdit = "/bp/entuba/single-leads/record/:id",
  BusinessPartnerEntubaSingleFormalization = "/bp/entuba/single-leads/record/formalization/:id",
  BusinessPartnerEntubaLeads = '/bp/entuba/leads',
  EntubaUpdateQuotaPostPurchase = '/entuba/cota/post/purchase',
  EntubaUpdateTradePricing = '/entuba/trade/pricing',
  BusinessPartnerEntubaLeadsDetail = '/bp/entuba/leads/:id',
  BusinessPartnerEntubaPorto = '/bp/entuba/porto',
  BusinessPartnerWorkflowContractinformation = '/bp/workflow/terms/pending',
  BusinessPartnerWorkflowAwaitingTransferTerm = '/bp/workflow/awaiting-transfer-term',
  BusinessPartnerWorkflowAwaitingTermsAndStatement = '/bp/workflow/awaiting-terms-and-statement',
  BusinessPartnerWorkflowCessionTerm = '/bp/workflow/terms/cession',
  BusinessPartnerWorkflowTransferTerm = '/bp/workflow/terms/transfer',
  BusinessPartnerWorkflowAnalysis = '/bp/workflow/analysis',
  BusinessPartnerWorkflowAdminApproval = '/bp/workflow/transfer/pending',
  BusinessPartnerWorkflowWallet = '/bp/workflow/wallet',
  BusinessPartnerWorkflowReadyDisbursement = '/bp/workflow/disbursement/ready',
  BusinessPartnerWorkflowRejectedDisbursement = '/bp/workflow/disbursement/reject',
  BusinessPartnerWorkflowEntubaCedenteBankData = '/bp/workflow/disbursement/cedente/update/entuba',

  BusinessPartnerConsorcieiWaitingSignatures = "/bp/workflow/consorciei/waiting_signatures",
  BusinessPartnerConsorcieiWaitingAnalysis = "/bp/workflow/consorciei/waiting_analysis",
  BusinessPartnerConsorcieiWaitingBuyerSignatures = "/bp/workflow/consorciei/waiting_buyer_signatures",
  BusinessPartnerConsorcieiWaitingTransference = "/bp/workflow/consorciei/waiting_transference",
  BusinessPartnerConsorcieiError = "/bp/workflow/consorciei/error",
  BusinessPartnerConsorcieiPendencies = "/bp/workflow/consorciei/pendencies",
  BusinessPartnerConsorcieiReport = "/bp/workflow/consorciei/report",

  EntubaFormalizationExtract = "/entuba/formalization/extract",

  PanReport = "/pan/report",

  PricingTradeApprovalPending = "/admin/pricing/trade/approval/pending",
  PricingDatasetPricingPending = "/admin/pricing/dataset/pricing/pending",
  PricingDatasetPricingPendingDetail = "/admin/pricing/dataset/pricing/pending/:id",

  // ----------------------------------------Premissas por Tipo-------------------------------------------------
  PremisesByType = "/partner/pricing/premisse/listbytype",
  // -----------------------------------------Premissas por Tipo-------------------------------------------------

  // ----------------------------------------Relatorio de Ofertas com Premissas---------------------------------
  PrincingBidReport = "/partner/pricing/bid/report"
  // ----------------------------------------Relatorio de Ofertas com Premissas---------------------------------

}



// WEBPACK FOOTER //
// ./src/layout/side-menu/MenuUrlEnum.ts